import type { ProductColorOption } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useStore } from 'zustand';
import { useEditAreaDraftStore } from '@/entities/edit-area';
import { CompositeAssetCard } from './composite-asset-card';

interface CompositeAssetUploadProps {
  readonly colors: readonly Pick<ProductColorOption, 'id' | 'name'>[];
}

/** '면 공통 합성 에셋' 줄 — 사용 중인 면마다 카드 하나. 색상과 무관한 면 공통 값이라 색상 카드 위에 둔다(Q8). */
export const CompositeAssetUpload = ({ colors }: CompositeAssetUploadProps): ReactElement => {
  const store = useEditAreaDraftStore();
  const activeFaces = useStore(store, (state) => state.draft.activeFaces);
  return (
    <section
      id="edit-area-composite"
      tabIndex={-1}
      aria-label="면 공통 합성 에셋"
      className="space-y-3 rounded border p-3"
    >
      <h3 className="font-semibold">면 공통 합성 에셋</h3>
      <p className="text-sm text-muted-foreground">
        마스크·음영은 알파 채널이 있는 PNG·WebP, 안내선은 PNG 만 올릴 수 있습니다. 세 에셋과 그 면의
        모든 색상 사진은 같은 px 크기여야 저장됩니다. 마스크는 원통 표면이 있는 면에 필수입니다.
      </p>
      <div className="grid gap-3 xl:grid-cols-2">
        {activeFaces.map((face) => (
          <CompositeAssetCard key={face} face={face} colors={colors} />
        ))}
      </div>
    </section>
  );
};
